import React, { useState } from 'react';
import { CloseIcon } from '../../utils/icons';
import colors from '../../utils/colors';

const SaveDescriptionModal = ({ onSave, onClose }) => {
  const [title, setTitle] = useState('');
  
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="w-[366px] flex flex-col rounded-3xl overflow-hidden" style={{ backgroundColor: colors.bg.tertiary }}>
        <div className="flex justify-between items-center p-6">
          <div className="w-10 h-10 opacity-0"></div>
          <h2 className="text-lg font-semibold" style={{ color: colors.text.primary }}>
            Save Description
          </h2>
          <button 
            onClick={onClose} 
            className="flex justify-center items-center w-10 h-10 rounded-full hover:bg-opacity-80 transition-colors"
            style={{ backgroundColor: colors.bg.glass.thick }}
          >
            <CloseIcon />
          </button>
        </div>
        <div className="flex flex-col gap-4 px-6">
          <p className="text-xs text-center" style={{ color: colors.text.tertiary }}>
            Give your description a title so it's easy to remember
          </p>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Description title"
            className="h-14 bg-transparent text-center text-sm font-medium border border-white/15 rounded-xl focus:outline-none"
            style={{ 
              fontFamily: 'PP Neue Montreal',
              fontWeight: 500,
              color: colors.text.primary,
              caretColor: colors.accent
            }}
          />
        </div>
        <div className="p-6">
          <button 
            onClick={() => onSave(title)} 
            className="w-full h-[56px] flex justify-center items-center rounded-full text-lg font-semibold hover:bg-opacity-90 transition-colors"
            style={{ 
              backgroundColor: colors.text.primary,
              color: colors.bg.primary 
            }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default SaveDescriptionModal;